import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      const sparkles = document.querySelectorAll( '.icon-sparkle-sm, .icon-sparkle-picker' );

      sparkles.forEach( ( el ) => {
        gsap.set( el, {
          scale: 0.8,
          rotation: Math.random() * 360,
          transformOrigin: '50% 50%',
        } );

        gsap.to( el, {
          scale: 1.2,
          duration: 1,
          repeat: -1,
          yoyo: true,
          ease: 'sine.inOut',
        } );

        function randomRotate() {
          gsap.to( el, {
            rotation: Math.random() * 360,
            duration: 1 + Math.random() * 2,
            ease: 'sine.inOut',
            delay: Math.random() * 0.5,
            onComplete: randomRotate,
          } );
        }

        randomRotate();
      } );

      document.querySelectorAll( '.graphic-wave-right' ).forEach( ( svg ) => {
        function animateClip() {
          gsap.fromTo(
              svg,
              {clipPath: 'inset(0% 100% 0% 0%)'},
              {
                clipPath: 'inset(0% 0% 0% 0%)',
                duration: 1.5 + Math.random() * 1.5,
                ease: 'sine.inOut',
                yoyo: true,
                repeat: -1,
                repeatDelay: 0.2 + Math.random() * 0.5,
                delay: Math.random(),
              },
          );
        }
        animateClip();
      } );

      document.querySelectorAll( '.graphic-wave-left' ).forEach( ( svg ) => {
        function animateClip() {
          gsap.fromTo(
              svg,
              {clipPath: 'inset(0% 0% 0% 100%)'},
              {
                clipPath: 'inset(0% 0% 0% 0%)',
                duration: 2 + Math.random() * 2,
                ease: 'sine.inOut',
                yoyo: true,
                repeat: -1,
                repeatDelay: 1 + Math.random() * 0.5,
                delay: Math.random(),
              },
          );
        }
        animateClip();
      } );
    },
    finalize: function() {
    },
    animate: function() {
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        $( `
        .js-fade:not(.js-ignore),
        .js-reveal:not(.js-ignore),
        .js-fade-group
        ` ).each( function() {
          gsap.registerPlugin( ScrollTrigger );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 95%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                if ( $( this ).hasClass( 'js-fade-group' ) ) {
                  $( this ).find( '> *' ).each( function( childKey, child ) {
                    const delay = ( childKey + 1 ) / 10;
                    child.style.setProperty( '--fade-group-delay', delay + 's' );
                  } );
                }
                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );
        $( `
          .js-fade.fade-on-load:not(.js-ignore),
          .js-reveal.fade-on-load:not(.js-ignore),
          .js-fade-group.fade-on-load
          ` ).each( function() {
          gsap.registerPlugin( ScrollTrigger );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 100%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                if ( $( this ).hasClass( 'js-fade-group' ) ) {
                  $( this ).find( '> *' ).each( function( childKey, child ) {
                    const delay = ( childKey + 1 ) / 10;
                    child.style.setProperty( '--fade-group-delay', delay + 's' );
                  } );
                }
                $( this ).addClass( 'js-animated' );
              },
            },
          } );
        } );
      }
    },
    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => {
        el.classList.remove( 'js-fade' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
